<div class="bn-dialog">
  <div class="bn-dialog__title">Upload OpenAPI Specification</div>
  <div
    class="bn-dialog__close"
    (click)="onClose()">
    <fa-icon
      class="pull-right"
      aria-label="Close"
      icon="xmark" />
  </div>
  <div class="bn-dialog__body">
    <bn-web-ui-upload-file
      [allowedFileTypes]="['json']"
      [isMultiple]="false"
      [allowMultipleFiles]="false"
      [ngModel]="null"
      (ngModelChange)="onFileSelected($event)" />
  </div>
</div>
